export default __webpack_public_path__ + "static/media/a90ce9a5d1054d8c4233d5b7ee7dfd9f.jpg";